var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#d38b5c;}")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("rect",{"className":"cls-1","x":"4.2","width":"2","height":"16","key":0}),React.createElement("polygon",{"className":"cls-1","points":"5.2 17.61 0 12.41 1.41 11 5.2 14.78 8.99 11 10.4 12.41 5.2 17.61","key":1})])]);
}

Arrow.defaultProps = {"viewBox":"0 0 10.4 17.61"};

module.exports = Arrow;

Arrow.default = Arrow;
